import React from 'react';

function ProductsTable({data, onRowClick, onRowDelete}) {
    // const totalSum = data.reduce((sum, item) => sum + parseFloat(item.totalPrice), 0);
    return (
        <div className='table-responsive'>
            <table className="table table-hover">
                <thead>
                <tr>
                    <th className='text-center'>ردیف</th>
                    <th className='text-center'>عنوان</th>
                    <th className='text-center'>شناسه</th>
                    <th className='text-center'>تعداد/مقدار</th>
                    <th className='text-center'>مبلغ واحد</th>
                    <th className='text-center'>نرخ مالیات بر ارزش افزوده</th>
                    <th className='text-center'>مبلغ کل</th>
                    {onRowDelete && (
                        <th className='text-center'>عملیات</th>
                    )}
                </tr>
                </thead>
                <tbody>
                {data.map((item, index) => {
                    return (
                        <tr key={index} onClick={() => onRowClick(item, index)} style={{cursor: "pointer"}}>
                            <td className='text-center'>{index + 1}</td>
                            <td className='text-center'>{item.name}</td>
                            <td className='text-center'>{item.productId}</td>
                            <td className='text-center'>{item.amount}</td>
                            <td className='text-center'>{item.unitPrice}</td>
                            <td className='text-center'>{item.taxPercent}</td>
                            <td className='text-center'>{item.totalPrice}</td>
                            {onRowDelete && (
                                <td className='text-center'>
                                    <svg onClick={(e) => {
                                        e.stopPropagation();
                                        onRowDelete(index);
                                    }} xmlns="http://www.w3.org/2000/svg" width="20" fill="#1740d8"
                                        className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                    </svg>
                                </td>
                            )}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}

export default ProductsTable